<div class="row">
  <div class="col-md-12 col-lg-2 display-none">
    <div class="form-group">
      <div class="left inline control-label mb-1">Published From</div>
      <div class="input-group input-group-sm">
        <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
          class="form-control form-control-sm" id="fromDate" placeholder="From" [(ngModel)]="regulationFilter.FromDate"
          readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
        </div>
      </div>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>

  <div class="col-md-12 col-lg-2 display-none">
    <div class="form-group">
      <div class="left inline control-label d-none d-sm-block mb-1">Published Until</div>
      <div class="input-group input-group-sm">
        <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
          class="form-control form-control-sm" id="toDate" placeholder="From" [(ngModel)]="regulationFilter.ToDate"
          readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
        </div>
      </div>
      <mat-datepicker #toPicker></mat-datepicker>
    </div>
  </div>
  <div class="col-md-12 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Geography</div>
      <mat-chip-list #geographyList>
        <mat-chip *ngFor="let geography of regulationFilter.Geography" [selectable]="selectable"
          [removable]="removable" (removed)="removeGeography(geography)">
          {{geography}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip>
        <input class="form-control form-control-sm mat-autodd-input" #geographyInput
          [formControl]="searchGeographyCntrl" [matAutocomplete]="geographyAutocomplete"
          [matChipInputFor]="geographyList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addGeography($event)">
      </mat-chip-list>
      <mat-autocomplete #geographyAutocomplete="matAutocomplete" (optionSelected)="selectedGeographyEvent($event)">
        <mat-option *ngFor="let geography of searchedGeography" [value]="geography.value">
          {{geography.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-12 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Country</div>
      <mat-chip-list #countryList>
        <mat-chip *ngFor="let country of regulationFilter.Country" [selectable]="selectable" [removable]="removable"
          (removed)="removeCountry(country)">
          {{country}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip>
        <input class="form-control form-control-sm mat-autodd-input" #countryInput [formControl]="searchCountryCntrl"
          [matAutocomplete]="countryAutocomplete" [matChipInputFor]="countryList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addCountry($event)">
      </mat-chip-list>
      <mat-autocomplete #countryAutocomplete="matAutocomplete" (optionSelected)="selectedCountryEvent($event)">
        <mat-option *ngFor="let country of searchedCountry" [value]="country.value">
          {{country.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-12 col-lg-2 display-none">
    <div class="form-group">
      <div class="left inline control-label mb-1">Regulator </div>
      <mat-chip-list #regulatorList [readonly]="user.planType === 5">
        <ng-container *ngFor="let regulator of regulationFilter.MappingID">
          <mat-chip [selectable]="selectable" [removable]="removable" (removed)="removeRegulator(regulator)">
            {{regulator}}
            <mat-icon matChipRemove *ngIf="removable && user.planType !== 5">x</mat-icon>
          </mat-chip>
        </ng-container>
        <input class="form-control form-control-sm mat-autodd-input" [readonly]="user.planType === 5"
          #regulatorInput [formControl]="searchRegulatorCntrl" [matAutocomplete]="regulatorAutocomplete"
          [matChipInputFor]="regulatorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRegulator($event)">
      </mat-chip-list>
      <mat-autocomplete #regulatorAutocomplete="matAutocomplete" (optionSelected)="selectedRegulatorEvent($event)">
        <mat-option *ngFor="let regulator of searchedRegulators" [value]="regulator.value">
          {{regulator.name}}
        </mat-option>
      </mat-autocomplete>
      <app-progress-bar [isLoading]="isLoadingFilters" class="loader-sm"></app-progress-bar>
    </div>
  </div>

  <div class="col-md-12 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Rulebook Name</div>
      <select class="form-control form-control-sm" [(ngModel)]="regulationFilter.RuleTypeName">
        <option *ngFor="let ruleBookType of ruleTypeNames" [ngValue]="ruleBookType">
          {{ruleTypeNameEnum[ruleBookType]}}
        </option>
      </select>
    </div>
  </div>

  <div class="col-md-12 col-lg-2">
    <div class="form-group">
      <div class="left inline control-label mb-1">Key Words</div>
      <mat-chip-list #keywordsList>
        <mat-chip *ngFor="let sQuery of regulationFilter.SearchQuery" [selectable]="selectable" [removable]="removable"
          (removed)="remove(sQuery)">
          {{sQuery}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip>
        <input class="form-control form-control-sm mat-autodd-input" #keywordInput [formControl]="keyCtrl"
          [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let fK of filteredKeywords | async" [value]="fK">
          {{fK}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-12 col-lg-2 display-none">
    <div class="form-group">
      <div class="left inline control-label mb-1">Title</div>
      <mat-chip-list #titleList>
        <mat-chip *ngFor="let title of regulationFilter.Title" [selectable]="selectable"
          [removable]="removable" (removed)="removeTitle(title)">
          {{title}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip>
        <input class="form-control form-control-sm" id="title" autocomplete="off" [matChipInputFor]="titleList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="addTitle($event)">
      </mat-chip-list>
    </div>
  </div>
  <div class="col-md-12 col-lg-2 float-right text-right pt-4">
    <div class="form-group">
      <button type="button" class="btn btn-sm bg-purple text-white ml-2 float-lg-right text-right btn-blue text-white"
        id="btn-search" (click)="TriggerAction()">Submit</button>
      <span class="float-right ml-2 btn btn-sm pl-1" (click)="initFilters()">Reset</span>
    </div>
  </div>
</div>
